import React from 'react';

import {
  freeTrialModalConfirmInfoTitle,
  freeTrialModalConfirmInfoSubtitle,
} from '../../../constants/Pages/FreeTrialReport';

import './NoFreeTrialModalTitle.css';

export const NoFreeTrialModalTitle = () => {
  return (
    <div>
      {freeTrialModalConfirmInfoTitle} <br />
      <div className="no-free-trial-subheader">{freeTrialModalConfirmInfoSubtitle} </div>{' '}
    </div>
  );
};
